import moment from "moment";
import React from "react";
import { compose } from "react-apollo";
import { Divider, Grid, Header, Segment } from "semantic-ui-react";
import { withPagination } from "../../../utils/pagination";
import PaginationWrapper from "../../PaginationWrapper";
import PathView from "../../PathView";
import { ScrollableGrid } from "../../styles/ScrollableGrid";
import ImportsTable from "./ImportsTable";
import TriggerPipelineButton from "./TriggerPipelineButton";
import withFlightImportsData from "./withFlightImportsData";

function ImportFlights({
  allFlightScheduleImports,
  nextFlightScheduleImport,
  pageInfo,
  totalCount
}) {
  return (
    <Segment className="o-fill c-Content__content">
      <PathView paths={[{ name: "Import Flights" }]} />
      <Divider hidden />
      <Grid verticalAlign="top" columns={2}>
        <Grid.Column width={12}>
          <div style={{ padding: ScrollableGrid.padding }}>
            <Header size="tiny">
              {nextFlightScheduleImport
                ? `Next import scheduled at ${moment(
                    nextFlightScheduleImport
                  ).format("DD/MM/YYYY")}`
                : null}
            </Header>
          </div>
        </Grid.Column>
        <Grid.Column width={4} textAlign="right">
          <TriggerPipelineButton />
        </Grid.Column>
      </Grid>
      <ImportsTable rows={allFlightScheduleImports} />
      <Divider hidden />
      <PaginationWrapper {...pageInfo} totalCount={totalCount} />
    </Segment>
  );
}

export default compose(withPagination(), withFlightImportsData)(ImportFlights);



// WEBPACK FOOTER //
// ./src/component/Maintenance/ImportFlights/index.js